import AdminZendeskLanguageMapSettings from "./components/Admin/AdminZendeskLanguageMapSettings";

require('./bootstrap');
require('./third_party/coolclock');
require('es6-promise/auto');

import Vue from 'vue';
import Vuex from 'vuex';
import tippy from 'tippy.js';
import {EventBus} from './event-bus.js';
import {CalendarCheckIcon, CommentTextIcon} from './components/icons.js';
import VTooltip from 'v-tooltip';
import ClickOutside from 'vue-click-outside';
import Switches from 'vue-switches';
import {ServerTable, ClientTable} from 'vue-tables-2';
import AcclaroNoresultsRow
    from './components/Acclaro-Datatable/components/Acclaro-Noresults-Row/AcclaroNoresultsRow.vue';
import AcclaroGridPagination
    from './components/Acclaro-Datatable/components/Acclaro-Grid-Pagination/AcclaroGridPagination.vue';
import Multiselect from 'vue-multiselect';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import GithubFilePicker from './components/Connectors/Filepickers/Github/FilePicker';
import ZendeskFilePicker from './components/Connectors/Filepickers/Zendesk/FilePicker';
import UploadFiles from './components/Create-Order/Upload-Files/UploadFiles';
import HubspotFilePicker from './components/Connectors/Filepickers/Hubspot/FilePicker';
import OneDriveFilePicker from './components/Connectors/Filepickers/OneDrive/FilePicker';
import TreeNode from './components/Connectors/Filepickers/Github/TreeNode';
import AdminUserConnectorSettings from './components/Admin/AdminUserConnectorSettings/admin-user-connector-settings';
import AdminUserTeamManagement from './components/Admin/admin-user-team-management';
import AccountDetails from './components/Accounts/AccountDetails';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import vSelect from 'vue-select';
import VModal from 'vue-js-modal';
import ProgressBar from 'vue-simple-progress'
import NotificationLogs from "./components/Admin/Notification-Logs/admin-notification-report"
import UserNotifications from "./components/User-Notifications/user-notifications"
import VueFormulate from '@braid/vue-formulate'
import createCache from 'vuex-cache';
import {mapGetters} from "vuex";
import AccountNav from './components/Accounts/AccountNav.vue';
import AccountProgramPreferences from './components/Accounts/Programs.vue';
import AdminOrderSearchResultView from './components/Acclaro-Search-V2/ResultViews/Admin/AdminOrderSearchResultsView';
import AcclaroModal from './components/Modal/acclaro-modal.vue';

//scss
import '../sass/share-modal.scss';

//tippy stylesheet
import 'tippy.js/dist/tippy.css';

//bugsnag
//turning off temporarily as it is creating too much noise
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

//store modules
import TRMOnBehalfStore from './store/modules/TRMOnBehalfStore';
import ReviewFormStore from './store/modules/ReviewFormStore';
import ReviewerImportFormStore from './store/modules/ReviewerImportFormStore';
import CreateOrderStore from './store/modules/CreateOrderStore';
import CreateProgramStore from './store/modules/models/Programs/CreateProgramStore';
import AuthStore from './store/modules/AuthStore';
import PortalNotificationStore from './store/modules/PortalNotificationStore';
import AccountReferencesStore from './store/modules/AccountReferencesStore';
import FeatureFlagStore from './store/modules/FeatureFlagStore';
import ConnectorTilesStore from './store/modules/ConnectorTilesStore';
import UserDataStore from './store/modules/UserDataStore';
import AcclaroSearchStore from './store/modules/AcclaroSearchStore';
import FeatureFlag from "./components/Admin/FeatureFlag/FeatureFlag";
import AdminAccountDetailsTeamStore from './store/modules/AdminAccountDetailsTeamStore';
import AdminAccountDetailsStore from './store/modules/AdminAccountDetailsStore';

import {
    CloseIcon,
} from './components/icons.js';

window.Vue = require('vue').default;
window.EventBus = EventBus;
window.commentState = {system: false, edits: false};
window.tippy = tippy;

// as this grows, move to a new file
// implement data shared between disconnected components using this store
// the store is shared amongst multiple different Vue initializations
Vue.use(Vuex);

export const store = new Vuex.Store({
        plugins: [
            createCache()
        ],
        modules: {
            TRMOnBehalfStore,
            ReviewFormStore,
            ReviewerImportFormStore,
            CreateOrderStore,
            FeatureFlagStore,
            PortalNotificationStore,
            AuthStore,
            ConnectorTilesStore,
            UserDataStore,
            AccountReferencesStore,
            AcclaroSearchStore,
            AdminAccountDetailsTeamStore,
            AdminAccountDetailsStore,
            CreateProgramStore
        }
    }
);


//Vue.use(ServerTable, [options = {}], [useVuex = false], [theme = 'bootstrap3'], [swappables = {}]);
Vue.use(
    ServerTable, {}, false, 'bootstrap3', {
        'pagination': AcclaroGridPagination,
        'noResultsRow': AcclaroNoresultsRow,
    }
);
Vue.use(
    ClientTable, {}, false, 'bootstrap3', {
        'pagination': AcclaroGridPagination,
        'noResultsRow': AcclaroNoresultsRow
    }
);
Vue.use(VTooltip);
Vue.use(VModal, {dialog: true});
Vue.use(VueFormulate);

try {
    // instantiate bugsnag only when the key is available
    if (process.env.MIX_BUGSNAG_JS_API_KEY && process.env.APP_ENV != 'local') {
        Bugsnag.start(
            {
                apiKey: process.env.MIX_BUGSNAG_JS_API_KEY,
                //enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'request', 'user'],
                plugins: [new BugsnagPluginVue(Vue)],
                releaseStage: process.env.APP_ENV,
                onError: function (event) {
                    event.addMetadata('user', auth)
                },
                beforeSend: function (report) {
                    // this metaData will override the original metaData
                    //report.metaData.releaseStage = process.env.BUGSNAG_RELEASE_STAGE;
                }
            }
        )
        //Bugsnag.notify(new Error('Test error'))
    }
} catch (error) {
    console.error(error);
}


Vue.component('multiselect', Multiselect);
Vue.component('loader', require('./components/UI/Loader').default);
Vue.component('toast-message', require('./components/UI/ToastMessage.vue').default);

Vue.component('nav-bar', require('./components/NavBar/NavBar.vue').default);
Vue.component('admin-nav-bar', require('./components/NavBar/AdminNavBar.vue').default);
Vue.component('project-manager-sub-nav-bar', require('./components/NavBar/ProjectManagerSubNavBar.vue').default);
Vue.component('admin-sub-nav-bar', require('./components/NavBar/AdminSubNavBar.vue').default);
Vue.component('header-nav', require('./components/NavBar/HeaderNav.vue').default);

Vue.component('acclaro-search-bar', require('./components/Acclaro-Search-Bar/AcclaroSearchBar.vue').default);
Vue.component('acclaro-filter', require('./components/Acclaro-Filter/AcclaroFilter.vue').default);
Vue.component('acclaro-multi-filter', require('./components/Acclaro-Filter/AcclaroOrderMultiFilter.vue').default);
Vue.component('acclaro-select', require('./components/Acclaro-Select/AcclaroSelect.vue').default);
Vue.component('acclaro-datatable', require('./components/Acclaro-Datatable/AcclaroDatatable.vue').default);
Vue.component('acclaro-order-datatable', require('./components/Acclaro-Datatable/AcclaroOrderDatatable.vue').default);
Vue.component('acclaro-grid', require('./components/Acclaro-Grid/AcclaroGrid.vue').default);

//Review Components
Vue.component('review', require('./components/Review/Review.vue').default);
Vue.component('review-request-form', require('./components/Review-Request-Form/ReviewRequestForm.vue').default);
Vue.component('review-import-form', require('./components/ReviewComponents/ReviewImportForm/ReviewImportForm.vue').default);
Vue.component('review-hero', require('./components/Review-Hero/ReviewHero.vue').default);
//

// Task Components
Vue.component('task-assigner', require('./components/Task-Assigner/TaskAssigner.vue').default);
Vue.component('task-assigner-form', require('./components/Task-Assigner-Form/TaskAssignerForm.vue').default);
Vue.component('task-completed-form', require('./components/Task-Completed-Form/TaskCompletedForm.vue').default);
Vue.component('task', require('./components/Task/Task.vue').default);

//Acclaro Components
Vue.component('acclaro-details', require('./components/Acclaro-Details/AcclaroDetails.vue').default);
Vue.component('acclaro-accordian', require('./components/Acclaro-Accordian/AcclaroAccordian.vue').default);
Vue.component('acclaro-inline-edit', require('./components/Acclaro-Inline-Edit/AcclaroInlineEdit').default);
Vue.component('review-tasks', require('./components/Review-Tasks/ReviewTasks.vue').default);
Vue.component('on-behalf', require('./components/OnBehalf/OnBehalf').default);
Vue.component('global-search', require('./components/GlobalSearch/GlobalSearch').default);

//commentS
Vue.component('comments', require('./components/Comments/Comments.vue').default);
Vue.component('orders-comments', require('./components/Comments/OrderComments/OrdersComments.vue').default);

//create order form Components
Vue.component('create-order', require('./components/Create-Order/CreateOrder.vue').default);

Vue.component('create-program', require('./components/Programs/CreateProgram.vue').default);

Vue.component('account-references', require('./components/Account-References/AccountReferences.vue').default);

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

// Connectors

//github
Vue.component('github-file-picker', GithubFilePicker);
Vue.component('tree-node', TreeNode);
//marketo
Vue.component('marketo-filepicker', require('./components/Marketo/Filepicker.vue').default);
Vue.component('marketo-child', require('./components/Marketo/MarketoChild.vue').default);
//zendesk
Vue.component('zendesk-file-picker', ZendeskFilePicker);

//hubspot

Vue.component('hubspot-file-picker', HubspotFilePicker);
Vue.component('onedrive-file-picker', OneDriveFilePicker);
// admin
Vue.component('admin-user-connector-settings', AdminUserConnectorSettings);
Vue.component('admin-user-team-management', AdminUserTeamManagement);
Vue.component('admin-notification-report', NotificationLogs);
Vue.component('user-notifications', UserNotifications);
Vue.component('zendesk-account-language-map', AdminZendeskLanguageMapSettings);
Vue.component('admin-feature-flag-settings', FeatureFlag);

Vue.component('account-details', AccountDetails);
Vue.component('account-program-preferences', AccountProgramPreferences);

//extensions
Vue.component('v-select', vSelect);
Vue.component('progress-bar', ProgressBar)

// Generate Token
Vue.component('generate-token', require('./components/Generate-Token/GenerateToken.vue').default);

//password portal
Vue.component('password-portal', require('./components/Portal/password.vue').default);

// Logged in devices
Vue.component('login-session-logs', require('./components/User/login-sessions/Log.vue').default);

// Admin pages listing
Vue.component('admin-pages', require('./components/Admin/Pages/list.vue').default);

// Date time picker
Vue.component('date-time-picker', require('./components/Date-Time/picker.vue').default);

//micro components
Vue.component('acclaro-text-editor', require('./components/Micro-Components/Acclaro-Text-Editor/AcclaroTextEditor.vue').default)
Vue.component('create-order-btn', require('./components/Micro-Components/Create-Order-Btn/CreateOrderBtn.vue').default);

//datatables components
Vue.component('orders-datatable', require('./components/Datatables/OrdersDatatable.vue').default)
Vue.component('purchase-orders-datatable', require('./components/Datatables/PurchaseOrdersDatatable.vue').default)
Vue.component('program-datatable', require('./components/Datatables/ProgramsDatatable.vue').default)
Vue.component('program-admin-datatable', require('./components/Datatables/ProgramsAdminDatatable.vue').default)
Vue.component('invoices-datatable', require('./components/Datatables/InvoicesDatatable.vue').default)
Vue.component('all-review-tasks-datatable', require('./components/Datatables/AllReviewTasksDatatable.vue').default)
Vue.component('my-review-tasks-datatable', require('./components/Datatables/MyReviewTasksDatatable.vue').default)
Vue.component('orders-admin-datatable', require('./components/Datatables/OrdersAdminDatatable.vue').default)
Vue.component('accounts-datatable', require('./components/Datatables/AccountsDatatable.vue').default)
Vue.component('orders-dashboard-datatable', require('./components/Datatables/OrdersDashboardDatatable.vue').default)
Vue.component('program-orders-datatable', require('./components/Datatables/ProgramOrdersDatatable.vue').default)
Vue.component('pm-orders-datatable', require('./components/Datatables/PMOrdersDatatable.vue').default)

// search with ES
Vue.component('admin-search-view', AdminOrderSearchResultView)

//Account order preferences
Vue.component('automated-emails', require('./components/Accounts/AutomatedEmails.vue').default);

export const app = new Vue({

        el: '.acclaro-vue-container',
        components: {},

        data: {
            hello: 'world'
        },
        store: store,
        methods: {
            triggerEvent(name, payload) {
                EventBus.$emit(name, payload);
            },
            fetchUserPreferences() {
                axios.get('/ajax/user_preferences')
                    .then(response => {
                        this.triggerEvent('user_preferences:loaded', response.data);
                    })
                    .catch(e => {
                        console.error('Something went wrong polling user preferences!');
                    });
            }

        },

        mounted() {
            window.onload = () => {
                EventBus.$emit('loader:hide');
            };
        },

    }
);

export const app_order_preferences = new Vue({

    el: '.acclaro-vue-order-preferences',
    components: {},

    data: {
        hello: 'world'
    },
    store: store,
    methods: {}
});

export const app_settings = new Vue(
    {

        el: '.acclaro-vue-settings',
        components: {},

        data: {
            //user settings email
            emailsToNotify: [],
            initialEmailsToNotify: '',
            emailOptions: [],
        },
        store: store,
        computed: {

            emailsToNotifyStr() {
                return this.emailsToNotify.toString();
            },

            requiredEmail() {
                return auth.email;
            }
        },
        methods: {

            onNotifyEmail(email) {
                this.emailsToNotify.push(email);
            },

            onEmailRemove(email) {
                //if user tries to delete their own email add it back
                if (email == auth.email) {
                    this.emailsToNotify.push(email);
                }
            },
        },

        beforeMount() {

            let emailsNotifySetup = () => {
                let $ele = this.$el.querySelector('#order_email_settings');

                if (!$ele) {
                    return;
                }

                this.initialEmailsToNotify = $ele.value;

                let initialEmails = this.initialEmailsToNotify.split(',');

                initialEmails.forEach(email => this.emailsToNotify.push(email));

                this.emailsToNotify.sort((a, b) => a == this.requiredEmail ? -1 : 1);
            }

            //check if the main vue element exists
            //if not don't run setup
            if (!this.$el.className) {
                return;
            }

            emailsNotifySetup();
        },

        mounted() {
        }
    }
);

const app_footer = new Vue(
    {
        el: '.acclaro-vue-footer',
        store: store,
        data: {},
        components: {},
        directives: {},
        computed: {},
        methods: {},
        mounted() {
        },
    }
)

const app_uploads = new Vue(
    {
        el: '.acclaro-updates',
        store: store,
        data: {},
        components: {
            UploadFiles
        },
        directives: {},

        mounted() {
        },

        computed: {

            ...mapGetters(
                'CreateOrderStore', [
                    'uploadedFiles',
                    'filesUploading'
                ]
            ),

            orderId() {
                return $('#order_id').val();
            },

            csrfToken() {
                return $('input[name=_token]').val();
            },

            fileType() {
                const urlParams = new URLSearchParams(window.location.search);
                const type = urlParams.get('tab');

                return type
            }
        },

        methods: {

            onFileUploading() {
            },

            onFileUploadComplete() {
            },

            /**
             * Confirm cancelling of uploaded files
             *
             * @param string redirectUrl
             * @param string isTask
             */
            confirmCancelFileUpload(redirectUrl, isTask = false) {
                if (!this.uploadedFiles.length) {
                    return window.location = redirectUrl;
                }

                let type = isTask ? 'task' : 'order';

                this.$modal.show(
                    'dialog', {
                        title: `Confirm Delete & Cancel`,
                        text: `
                        <p>Cancel adding files to this ${type}? Any uploaded files will be deleted. You will be returned to the ${type}.</p>
                        `,
                        buttons: [
                            {
                                title: 'Continue',
                                class: 'vue-dialog-button reviewer-dialog-btn dialog-confirm-btn',
                                handler: () => {
                                    this.cancelFileUpload(redirectUrl);
                                }
                            },
                            {
                                title: 'Cancel',
                                class: 'vue-dialog-button reviewer-dialog-btn close-btn',
                                handler: () => {
                                    this.$modal.hide('dialog')
                                }
                            }
                        ]
                    }
                );
            },

            /**
             * Remove uploaded files and redirect to url
             *
             * @param string redirectUrl
             */
            cancelFileUpload(redirectUrl) {
                this.$refs.uploadFiles.removeAllPondFiles()

                setTimeout(
                    () => {
                        window.location = redirectUrl;
                    }, 600
                )
            }
        }
    }
);

const app_minimal = new Vue(
    {

        el: '.acclaro-vue-content',
        store: store,
        data: {
            acclaroModal: {
                show: false,
            },
            hello: 'world',
            editor: '',
            showCommentsComponent: true,
            wordTrackerFilters: {},
            searchResultsVisible: false,
            renderComponent: true,
            showFilelessTaskAssigner: false,
            commentToggles: {
                edit: false,
                system: false,
            }
        },

        components: {
            Switches,
            CalendarCheckIcon,
            CommentTextIcon,
            AccountNav,
            AcclaroModal,
            CloseIcon
        },

        directives: {
            ClickOutside
        },

        methods: {
            toggleCommentsComponent(state) {
                return this.showCommentsComponent = state;
            },

            strToPrice(amount) {
                let amountFloat = parseFloat(amount);

                if (isNaN(amountFloat) || amountFloat == 0) {
                    return '-';
                }

                return '$' + (this.numberWithCommas(amountFloat.toFixed(2)));
            },

            numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },

            triggerEvent(name, payload) {
                EventBus.$emit(name, payload);
            },

            toggleSwitch(name, $event) {
            },

            toggleFilelessTaskAssigner(state) {
                this.showFilelessTaskAssigner = state;
            },

            reloadSearchView() {
                this.$refs.reviewTasks.refreshTable();
            },

            hideSearch() {
                //@todo - fix this
                $('#reses').hide().empty();
            },

            updateFilters(data) {
                const {key, list_id} = data;

                axios.get(`/dashboard/widget?f=${list_id}&v=${key}`)
                    .then(this.onWordTrackerFilters);
            },

            getWordTrackerFilters() {
                return axios.get('/dashboard/widget?f=wt');
            },

            fetchUserPreferences() {
                axios.get('/ajax/user_preferences')
                    .then(
                        response => {
                            this.triggerEvent('user_preferences:loaded', response.data);
                        }
                    )
                    .catch(
                        e => {
                            console.error('Something went wrong polling user preferences!');
                        }
                    );
            },

            onWordTrackerFilters(response) {
                let languageItemsObj = {};
                const {filters, word_count} = response.data;
                const languagesArr = filters.languages.options.slice();

                filters.languages.options.forEach(
                    function (language) {
                        let {enabled, id, description} = language;
                        if (enabled) {
                            languageItemsObj[id] = description;
                        }
                    }
                );

                filters.languages.options = languageItemsObj;
                this.wordTrackerFilters = filters;

                //todo:update word count html in own component
                const $wordTrackerValue = $('#wtvalue');

                if ($wordTrackerValue) {
                    const selectedItem = languagesArr.find(item => item.id == filters.languages.selectedOption);
                    const $wcbLabel = $wordTrackerValue.find('.wcb-label');

                    if (selectedItem) {
                        $wordTrackerValue.find('.wcb-value').html(word_count);

                        let wordText = selectedItem.id == 'all' ? 'All' : selectedItem.description;

                        $wcbLabel
                            .html(`<span data-click="open-acclaro-filters">${wordText}</span> <span>Words</span>`)
                            .toggleClass('has-selection', true);

                        $('[data-click="open-acclaro-filters"]').off('click');
                        $('[data-click="open-acclaro-filters"]').on(
                            'click', function () {
                                EventBus.$emit('word_tracker:filter:open');
                            }
                        );
                    } else {
                        $wcbLabel.toggleClass('has-selection', false);
                    }
                }
            },

            getTaskNavUrls(taskId, routeid, isReviewer) {
                let routes = [{
                    id: 'task',
                    href: `/my-review-tasks/${taskId}`,
                    name: 'Task',
                    active: routeid === 'task'
                }, {
                    id: 'comments',
                    href: `/my-review-tasks/${taskId}/comments`,
                    name: 'Review Task Comments',
                    active: routeid === 'comments'
                }];

                if (!isReviewer) {
                    routes.push(
                        {
                            id: 'edit',
                            href: `/my-review-tasks/${taskId}/edit`,
                            name: 'Edit',
                            active: routeid === 'edit'
                        }
                    )
                }

                return routes;
            },

            getStatusColor(status) {
                const reviewStatusColors = {
                    'assigned': '#1F8CEE',
                    'open': '#1F8CEE',
                    'complete': '#68C71E',
                    'canceled': '#000000'
                };

                return reviewStatusColors[status];
            },

        },

        mounted() {

            let $filters = $('.filter-opt-container');

            if ($filters.length) {
                this.getWordTrackerFilters().then(this.onWordTrackerFilters);
            }

            EventBus.$on('acclaro-modal:files-download:error', () => {
                this.acclaroModal.show = true;
            })

            EventBus.$on(
                'user_preferences:reload', () => {
                    this.fetchUserPreferences();
                }
            );
        }

    }
);

Vue.config.devtools = true;

// sanitize user input
window.sanitizeString = function (string) {
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        "/": '&#x2F;',
    };
    const reg = /[&<>"'/]/ig;
    return string.replace(reg, (match) => (map[match]));
}
